import { FC } from 'react';

type Props = {
  url?: string;
  alt?: string;
  text?: string;
  index: number;
};
const MediaViewImage: FC<Props> = ({ url, alt, text, index }) => {
  return (
    <div className="image-item w-full m-auto h-auto flex flex-col items-center">
      <picture>
        <img
          className="object-contain m-auto h-auto w-auto max-h-sm md:max-h-md lg:max-h-[95vh] min-h-[260px]"
          src={url}
          alt={alt || ''}
          loading={index > 3 ? 'lazy' : 'eager'}
          width={1440}
          height={960}
        />
      </picture>
      {text && <span className="py-2">{text}</span>}
    </div>
  );
};
export default MediaViewImage;
